export default __webpack_public_path__ + "static/media/sanka.70bd47e7.jpg";